<script>
export default {
	methods: {
		showAutoRemovalsModal() {
			this.$store.set('cart/showCartAutoRemovals', true)
		},
	},
}
</script>

<template>
	<div v-if="$store.get('cart/cartAutoRemovals')" class="my-1">
		<span @click="showAutoRemovalsModal" class="pointer pa-1 rounded warning font-0"
			>Hubo cambios en tu carrito</span
		>
	</div>
</template>

